import { StytchB2BHeadlessClient } from "@stytch/vanilla-js/b2b";

// Only constructed when SSO is enabled and a public token is configured —
// mirrors coverflow_fe's stytchClient pattern.
const isSsoEnabled = process.env.REACT_APP_SSO_ENABLED === "true";
const publicToken = process.env.REACT_APP_STYTCH_PUBLIC_TOKEN;

// Own cookie names so this app's Stytch session never collides with coverflow_fe's
// (default stytch_session*) on the shared domain. Must match the backend's
// utils.STYTCH_ADMIN_SESSION_COOKIE_NAMES.
const cookieOptions = {
  opaqueTokenCookieName: "stytch_admin_session",
  jwtCookieName: "stytch_admin_session_jwt",
  istCookieName: "stytch_admin_intermediate_session_token",
};

const stytchClient =
  isSsoEnabled && publicToken ? new StytchB2BHeadlessClient(publicToken, { cookieOptions }) : null;

export default stytchClient;
